export default __webpack_public_path__ + "static/media/image1.537676f3.png";